import "./Breeds.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import DogBreeds from "./sections/DogBreeds";
import CatBreeds from "./sections/CatBreeds";
import Footer from "@/reusable_sections/Footer";
export default function BreedsPage() {
  return <div>
      <Header />
      <Intro />
      <DogBreeds />
      <CatBreeds />
      <Footer />
    </div>;
}